import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { BlockSpinner } from 'components/spinner/Spinner'
import { ToggleAudioButton } from 'components/toggleAudioButton/ToggleAudioButton'
import { BREAKPOINTS, pxToRem } from 'utils/styled'

export const SMemoryView = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const SSpinner = styled(BlockSpinner)`
  color: var(--c-blue500);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin-left: 0;
`

export const SActions = styled.div`
  width: 200px;
  height: 50px;
`

export const SMemoryImageTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  width: 100%;
  height: 100%;
  padding: 30%;
  @media ${BREAKPOINTS.LG.max} {
    padding: 25%;
  }
  text-align: center;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  & > div {
    margin-bottom: ${pxToRem(12)}rem;
  }
  & > p {
    color: white;
    font-weight: bold;
    width: 300px;
    max-width: 60vw;
  }
`

export const SNavButton = styled.div`
  position: absolute;
  border-radius: 100%;
  line-height: 0;
  top: calc(50% - 18px);
  cursor: pointer;
  background: var(--c-white-transparent);
  box-shadow: var(--card-shadow);

  & > svg {
    color: white;
  }
`

export const SLeftNavButton = styled(SNavButton)`
  transform: scaleX(-1);
  left: 2rem;
`

export const SRightNavButton = styled(SNavButton)`
  right: 2rem;
`

export const SBottomBar = styled.div`
  display: flex;
  flex-direction: row-reverse;
  height: ${pxToRem(75)}rem;
  align-items: center;
  width: 100%;
  justify-content: space-between;

  @media ${BREAKPOINTS.LG.min} {
    display: none;
  }
`

const tabletQuery = `(hover: none) and (min-width: ${BREAKPOINTS.MD.size}px)`

export const SToggleAudioButton = styled(ToggleAudioButton)`
  position: absolute;
  bottom: 1rem;
  left: 1rem;
  @media ${tabletQuery} {
    /* iPad Air seems to overlap the toggle button in case the spacing is 1rem */
    bottom: 2.5rem;
    left: 2.5rem;
  }
`

export const contentCss = css`
  max-width: 100vmin;
  min-width: 100vmin;
  max-height: 100vmin;
  min-height: 100vmin;
`
